export type Environment = "dev" | "test" | "qa" | "staging" | "production";

export type InstallDomain = "gcgra" | "onecomply";

type Env = {
  /** Required Parameters */
  MODE: "development" | "production";
  APP_BASE_URL: string;
  API_BASE_URL: string;
  ENVIRONMENT: Environment;
  APP_NAME: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_DOMAIN: string;
  AUTH0_AUDIENCE: string;
  RECAPTCHA_SITEKEY: string;
  CDN_URL: string;
  DOMAIN: string;
  INSTALL_DOMAIN: InstallDomain;

  /** Optional Parameters */
  SENTRY_DSN?: string;

  /** Derived Parameters */
  IS_DEVELOPMENT: boolean;
  IS_NOT_DEVELOPMENT: boolean;
  IS_QA: boolean;
  IS_STAGING: boolean;
  IS_PRODUCTION: boolean;
  IS_NOT_PRODUCTION: boolean;
  IS_GCGRA: boolean;
  IS_ONECOMPLY: boolean;
};

const viteMode = import.meta.env.MODE;

const installDomain = viteMode.split("-")[0] as InstallDomain;

export const ENV: Env = {
  MODE: import.meta.env.MODE as "development" | "production",
  APP_BASE_URL: import.meta.env.VITE_APP_BASE_URL ?? "http://localhost:5000",
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:4001/api/v1",

  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT ?? "qa",
  IS_DEVELOPMENT: import.meta.env.VITE_ENVIRONMENT === "dev",
  IS_NOT_DEVELOPMENT: ["qa", "staging", "production"].includes(import.meta.env.VITE_ENVIRONMENT),
  IS_QA: import.meta.env.VITE_ENVIRONMENT === "qa",
  IS_STAGING: import.meta.env.VITE_ENVIRONMENT === "staging",
  IS_PRODUCTION: import.meta.env.VITE_ENVIRONMENT === "production",
  IS_NOT_PRODUCTION: ["dev", "qa", "staging"].includes(import.meta.env.VITE_ENVIRONMENT),

  APP_NAME: import.meta.env.VITE_APP_NAME,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID ?? "",
  AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN ?? "",
  AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
  RECAPTCHA_SITEKEY: import.meta.env.VITE_RECAPTCHA_SITEKEY ?? "6LfvCXsnAAAAAC6WRoL1Bf5M0r7uf4Ej72OYin_Q",
  CDN_URL: import.meta.env.VITE_CDN_URL,
  DOMAIN: import.meta.env.VITE_DOMAIN ?? "localhost",

  INSTALL_DOMAIN: installDomain,
  IS_GCGRA: installDomain === "gcgra",
  IS_ONECOMPLY: installDomain === "onecomply",
};
